module.exports = __webpack_public_path__ + "static/media/logo192.a2d1d693.png";